module.exports = __webpack_public_path__ + "static/media/product-service-banner2.68661593.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/productService/images/product-service-banner2.jpg
// module id = 151
// module chunks = 0